import { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { imageAssetUrl } from '../../../utils/publicAssets';
import { track } from '../../../utils/track';

const roadmapImages = [
  imageAssetUrl('05_08_2006_Roadmap_1.png'),
  imageAssetUrl('05_08_2006_Roadmap_2.png'),
  imageAssetUrl('05_08_2006_Roadmap_3.png'),
  imageAssetUrl('05_08_2006_Roadmap_4.png'),
  imageAssetUrl('05_08_2006_Roadmap_5.png'),
  imageAssetUrl('05_08_2006_Roadmap_6.png')
];

const Roadmap = () => {
  // Static marketing page: the only real engagement signal is whether the user
  // scrolled through the whole roadmap or bounced at the top. A bottom sentinel +
  // IntersectionObserver reports "reached the end" once, container-agnostic.
  const endRef = useRef<HTMLDivElement | null>(null);
  const firedRef = useRef(false);
  useEffect(() => {
    const el = endRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver(
      (entries) => {
        if (!firedRef.current && entries.some((en) => en.isIntersecting)) {
          firedRef.current = true;
          track('roadmap.reached_end');
          io.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'center',
        px: { xs: 0, md: 2 },
        py: 0
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 1000,
          mx: 'auto'
        }}
      >
        <Box sx={{ px: { xs: 1.5, md: 0 }, pt: 1, pb: 2 }}>
          <Typography
            sx={{
              font: '800 10px ui-monospace, Menlo, Consolas, monospace',
              letterSpacing: '0.4em',
              textTransform: 'uppercase',
              color: '#ffcf40'
            }}
          >
            Roadmap
          </Typography>
          <Typography
            sx={{
              mt: 1.25,
              fontWeight: 900,
              fontSize: 'clamp(24px, 3.4vw, 36px)',
              lineHeight: 1,
              letterSpacing: '-0.02em',
              color: '#e8f4fb'
            }}
          >
            Where we&apos;re{' '}
            <Box component="span" sx={{ color: '#38e8ff' }}>
              headed
            </Box>
          </Typography>
        </Box>
        {roadmapImages.map((src, index) => (
          <Box
            component="img"
            key={src}
            src={src}
            alt={`Incrypt roadmap ${index + 1}`}
            sx={{
              display: 'block',
              width: '100%',
              maxWidth: 1000,
              height: 'auto',
              objectFit: 'contain'
            }}
          />
        ))}
        <Box ref={endRef} sx={{ height: 1 }} />
      </Box>
    </Box>
  );
};

export default Roadmap;
